export const BASKET_CONSTANTS = {
  ADD_ITEM: 'ADD_ITEM',
  REMOVE_ITEM: 'REMOVE_ITEM',
  UPDATE_BASKET: 'UPDATE_BASKET',
  UPDATE_ITEM_QUANTITY: 'UPDATE_ITEM_QUANTITY',
  INCREMENT_ITEM_QTY: 'INCREMENT_ITEM_QTY',
  DECREMENT_ITEM_QTY: 'DECREMENT_ITEM_QTY',
  CLEAR_BASKET: 'CLEAR_BASKET',
};
